import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ORDER_UPDATE_STATUS, {
      pathParams: {
        orderId: id,
      },
    })
  },

  method: 'POST',

  format(payload) {
    const { id, status, reason } = payload || {}
    return {
      orderId: id,
      newStatus: status,
      reason
    }
  },

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to update order status',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Statut de la commande mis à jour',
      data: raw.data,
    }
  },
}
